var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-tabs-all-fase",class:_vm.componentClasses},_vm._l((_vm.openStatus),function(status){return _c('status-tab',{key:("status-" + status),attrs:{"status":status}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }